export const IS_TRANS_LOADING = 'IS_TRANS_LOADING';
export const TRANS_HAS_ERROR = 'TRANS_HAS_ERROR';
export const TRANS_FETCH_DATA_SUCCESS = 'TRANS_FETCH_DATA_SUCCESS';
export const IS_PLAYER_LOADING = 'IS_PLAYER_LOADING';
export const PLAYERS_HAS_ERROR = 'PLAYERS_HAS_ERROR';
export const PLAYERS_FETCH_DATA_SUCCESS = 'PLAYERS_FETCH_DATA_SUCCESS';
export const IS_PLAYER_RECOMENDATION_LOADING = 'IS_PLAYER_RECOMENDATION_LOADING';
export const SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE = 'SET_PLAYER_RECOMENDATION_FIRST_POPUP_FALSE';
export const PLAYER_RECOMENDATION_POPUP_SHOW_HIDE = 'PLAYER_RECOMENDATION_POPUP_SHOW_HIDE';
export const SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB = 'SHOW_HIDE_PLAYER_RECOMD_TOGGLE_WEB';
export const SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB = 'SHOW_HIDE_PLAYER_RECOM_POP_UP_MOB';
export const SHOW_OR_HIDE_PLAYERRECOM_ON_MOB = 'SHOW_OR_HIDE_PLAYERRECOM_ON_MOB';
export const TOGGLE_SORT_BY_FOR_PLAYER_LIST = 'TOGGLE_SORT_BY_FOR_PLAYER_LIST';
export const SET_PLAYER_RECOMENDATION_KEY = 'SET_PLAYER_RECOMENDATION_KEY';
export const SHOW_PLAYER_RECOMD_MOB_POP_UP = 'SHOW_PLAYER_RECOMD_MOB_POP_UP';
export const PLAYER_RECOMENDATION_SUCCESS = 'PLAYER_RECOMENDATION_SUCCESS';
export const PLAYER_RECOMENDATION_ERROR = 'PLAYER_RECOMENDATION_ERROR';
export const IS_BADGES_LOADING = 'IS_BADGES_LOADING';
export const BADGES_HAS_ERROR = 'BADGES_HAS_ERROR';
export const BADGES_FETCH_DATA_SUCCESS = 'BADGES_FETCH_DATA_SUCCESS';
export const IS_FORMATION_LOADING = 'IS_FORMATION_LOADING';
export const FORMATIONS_HAS_ERROR = 'FORMATIONS_HAS_ERROR';
export const FORMATIONS_FETCH_DATA_SUCCESS = 'FORMATIONS_FETCH_DATA_SUCCESS';
export const IS_CLUBS_LOADING = 'IS_CLUBS_LOADING';
export const CLUBS_HAS_ERROR = 'CLUBS_HAS_ERROR';
export const CLUBS_FETCH_DATA_SUCCESS = 'CLUBS_FETCH_DATA_SUCCESS';
export const FORMATIONS_VISIBILITY_UPDATE = 'FORMATIONS_VISIBILITY_UPDATE';
export const CREATE_TEAM = 'CREATE_TEAM';
export const ADD_OR_REMOVE_PLAYER = 'ADD_OR_REMOVE_PLAYER';
export const IS_CONSTRAINTS_LOADING = 'IS_CONSTRAINTS_LOADING';
export const CONSTRAINTS_HAS_ERROR = 'CONSTRAINTS_HAS_ERROR';
export const CONSTRAINTS_SUCCESS = 'CONSTRAINTS_FETCH_DATA_SUCCESS';
export const UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY = 'UPDATE_MOBILE_PLAYER_LISTING_VISIBILITY';
export const RESET_ERROR = 'RESET_ERROR';
export const OPEN_MOBILE_FILTER = 'OPEN_MOBILE_FILTER';
export const RESET_API_ERROR = 'RESET_ERROR';
export const RESET_SKILL_FILTER = 'RESET_SKILL_FILTER';
export const SET_BADGE = 'SET_BADGE';
export const SET_TEAM_NAME = 'SET_TEAM_NAME';
export const SET_CLUB_ID = 'SET_CLUB_ID';
export const SET_HIGHLIGHT = 'SET_HIGHLIGHT';
export const MAKE_CAPTAIN = 'MAKE_CAPTAIN';
export const REMOVE_CAPTAIN = 'REMOVE_CAPTAIN';
export const REMOVE_PLAYER = 'REMOVE_PLAYER';
export const RESET_TEAM = 'RESET_TEAM';
export const RESET_COMMON_ERROR = 'RESET_COMMON_ERROR';
export const AUTO_FILL = 'AUTO_FILL';
export const SET_TUTORIAL_COOKIE = 'SET_TUTORIAL_COOKIE';
export const SET_MANAGE_TEAM_TUTORIAL_COOKIE = 'SET_MANAGE_TEAM_TUTORIAL_COOKIE';
export const SET_SUBSTITUTION_TUTORIAL_COOKIE = 'SET_SUBSTITUTION_TUTORIAL_COOKIE';
export const IS_TEAM_NAME_VALIDATION_LOADING = 'IS_TEAM_NAME_VALIDATION_LOADING';
export const TEAM_NAME_VALIDATION_HAS_ERROR = 'TEAM_NAME_VALIDATION_HAS_ERROR';
export const TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS = 'TEAM_NAME_VALIDATION_FETCH_DATA_SUCCESS';
export const INITIAL_LOGIN_COMPLETED = 'INITIAL_LOGIN_COMPLETED';
export const IS_LOGIN_LOADING = 'IS_LOGIN_LOADING';
export const LOGIN_HAS_ERROR = 'LOGIN_HAS_ERROR';
export const LOGIN_FETCH_DATA_SUCCESS = 'LOGIN_FETCH_DATA_SUCCESS';
export const IS_SAVE_TEAM_LOADING = 'IS_SAVE_TEAM_LOADING';
export const SAVE_TEAM_HAS_ERROR = 'SAVE_TEAM_HAS_ERROR';
export const SAVE_TEAM_FETCH_DATA_SUCCESS = 'SAVE_TEAM_FETCH_DATA_SUCCESS';
/*---Filters----*/
export const TOGGLE_FILTERS_FOR_WEB = 'TOGGLE_FILTERS_FOR_WEB';
export const TOGGLE_PRIZE_BOX_FOR_WEB = 'TOGGLE_PRIZE_BOX_FOR_WEB';
export const TOGGLE_PRIZE_BOX_FOR_MOBILE = 'TOGGLE_PRIZE_BOX_FOR_MOBILE';
export const TOGGLE_CLUB_FILTER_FOR_WEB = 'TOGGLE_CLUB_FILTER_FOR_WEB';
export const TOGGLE_SEARCH_FOR_BOTH = 'TOGGLE_SEARCH_FOR_BOTH';
export const TOGGLE_SORT_BY_FOR_WEB = 'TOGGLE_SORT_BY_FOR_WEB';
export const APPLY_SEARCH = 'APPLY_SEARCH';
export const APPLY_PRIZE = 'APPLY_PRIZE';
export const APPLY_PLAYER_SORT = 'APPLY_PLAYER_SORT';
export const APPLY_SORT_BY = 'APPLY_SORT_BY';
export const APPLY_SKILL_FILTER = 'APPLY_SKILL_FILTER';
export const APPLY_CLUB = 'APPLY_CLUB';
export const RESET_TEAM_FILTER = 'RESET_TEAM_FILTER';
export const RESET_FILTER = 'RESET_FILTER';
export const RESET_ALL_FILTER = 'RESET_ALL_FILTER';
/*-----/Filters-----*/
export const TOGGLE_PROGRESS_ANIMATION = 'TOGGLE_PROGRESS_ANIMATION';
/*-----/PlayerCard/------*/
export const IS_PLAYER_CARD_LOADING = 'IS_PLAYER_CARD_LOADING';
export const PLAYER_CARD_HAS_ERROR = 'PLAYER_CARD_HAS_ERROR';
export const PLAYER_CARD_FETCH_DATA_SUCCESS = 'PLAYER_CARD_FETCH_DATA_SUCCESS';
export const TRIGGER_HANDLE_PLAYER_CARD = 'TRIGGER_HANDLE_PLAYER_CARD';
// live scoring api call
export const LIVE_SCORE_FETCH_DATA_SUCCESS = 'LIVE_SCORE_FETCH_DATA_SUCCESS';
export const IS_LIVE_SCORE_LOADING = 'IS_LIVE_SCORE_LOADING';
export const LIVE_SCORE_HAS_ERROR = 'LIVE_SCORE_HAS_ERROR';
export const MIX_FETCH_DATA_SUCCESS = 'MIX_FETCH_DATA_SUCCESS';
/*-----/GamerCard - Home/------*/
export const IS_GAMER_CARD_LOADING = 'IS_GAMER_CARD_LOADING';
export const GAMER_CARD_HAS_ERROR = 'GAMER_CARD_HAS_ERROR';
export const GAMER_CARD_FETCH_DATA_SUCCESS = 'GAMER_CARD_FETCH_DATA_SUCCESS';
export const IS_FIXTURE_LOADING = 'IS_FIXTURE_LOADING';
export const FIXTURE_HAS_ERROR = 'FIXTURE_HAS_ERROR';
export const FIXTURE_FETCH_DATA_SUCCESS = 'FIXTURE_FETCH_DATA_SUCCESS';
export const IS_USER_PLAYED_GAME_DAYS_LOADING = 'IS_USER_PLAYED_GAME_DAYS_LOADING';
export const USER_PLAYED_GAME_DAYS_HAS_ERROR = 'USER_PLAYED_GAME_DAYS_HAS_ERROR';
export const USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS = 'USER_PLAYED_GAME_DAYS_FETCH_DATA_SUCCESS';
export const IS_GET_TEAM_LOADING = 'IS_GET_TEAM_LOADING';
export const GET_TEAM_HAS_ERROR = 'GET_TEAM_HAS_ERROR';
export const GET_TEAM_FETCH_DATA_SUCCESS = 'GET_TEAM_FETCH_DATA_SUCCESS';
export const CREATE_MANAGE_TEAM_SKELETON = 'CREATE_MANAGE_TEAM_SKELETON';
export const RESET_TRANSFERS = 'RESET_TRANSFERS';
export const GET_USER_SPECIFIC_FIXTURES = 'GET_USER_SPECIFIC_FIXTURES';
export const SUBSTITUTE_THIS_PLAYER = 'SUBSTITUTE_THIS_PLAYER';
export const IS_SUBSCRIBE_LOADING = 'IS_SUBSCRIBE_LOADING';
export const SUBSCRIBE_HAS_ERROR = 'SUBSCRIBE_HAS_ERROR';
export const SUBSCRIBE_FETCH_DATA_SUCCESS = 'SUBSCRIBE_FETCH_DATA_SUCCESS';
export const REPLACE_WITH_THIS_PLAYER = 'REPLACE_WITH_THIS_PLAYER';
export const CANCEL_SUBSTITUTION = 'CANCEL_SUBSTITUTION';
export const RESET_SUBSTITUTION = 'RESET_SUBSTITUTION';
export const RESET_TEAM_DATA = 'RESET_TEAM_DATA';
export const RESET_CREATE_TEAM_ERROR = 'RESET_CREATE_TEAM_ERROR';
export const UPDATE_CURRENT_ACTIVE_FIXTURE = 'UPDATE_CURRENT_ACTIVE_FIXTURE';
export const SET_MANAGE_TEAM_MODE = 'SET_MANAGE_TEAM_MODE';
export const IS_DREAM_TEAM_LOADING = 'IS_DREAM_TEAM_LOADING';
export const DREAM_TEAM_HAS_ERROR = 'DREAM_TEAM_HAS_ERROR';
export const DREAM_TEAM_SUCCESS = 'DREAM_TEAM_SUCCESS';
/*-----/save transfer api/------*/
export const IS_TRANSFER_TEAM_LOADING = 'IS_TRANSFER_TEAM_LOADING';
export const TRANSFER_TEAM_FETCH_DATA_SUCCESS = 'TRANSFER_TEAM_FETCH_DATA_SUCCESS';
export const TRANSFER_TEAM_HAS_ERROR = 'TRANSFER_TEAM_HAS_ERROR';
/*-----/save limitless api/------*/
export const IS_LIMITLESS_TEAM_LOADING = 'IS_LIMITLESS_TEAM_LOADING';
export const LIMITLESS_TEAM_FETCH_DATA_SUCCESS = 'LIMITLESS_TEAM_FETCH_DATA_SUCCESS';
export const LIMITLESS_TEAM_HAS_ERROR = 'LIMITLESS_TEAM_HAS_ERROR';
/*-----/news editorial api/------*/
export const IS_EDITORIAL_CARD_LOADING = 'IS_EDITORIAL_CARD_LOADING';
export const EDITORIAL_CARD_FETCH_DATA_SUCCESS = 'EDITORIAL_CARD_FETCH_DATA_SUCCESS';
export const EDITORIAL_CARD_HAS_ERROR = 'EDITORIAL_CARD_HAS_ERROR';
/*-----Leagues API-----*/
export const IS_GET_LEAGUES_LOADING = 'IS_GET_LEAGUES_LOADING';
export const LEAGUES_FETCH_DATA_SUCCESS = 'LEAGUES_FETCH_DATA_SUCCESS';
export const LEAGUES_HAS_ERROR = 'LEAGUES_HAS_ERROR';
export const IS_GET_LEAGUE_MEMBERS_LOADING = 'IS_GET_LEAGUE_MEMBERS_LOADING';
export const LEAGUE_MEMBERS_FETCH_DATA_SUCCESS = 'LEAGUE_MEMBERS_FETCH_DATA_SUCCESS';
export const LEAGUE_MEMBERS_HAS_ERROR = 'LEAGUE_MEMBERS_HAS_ERROR';
export const IS_CREATE_LEAGUE_LOADING = 'IS_CREATE_LEAGUE_LOADING';
export const CREATE_LEAGUE_FETCH_DATA_SUCCESS = 'CREATE_LEAGUE_FETCH_DATA_SUCCESS';
export const CREATE_LEAGUE_HAS_ERROR = 'CREATE_LEAGUE_HAS_ERROR';
export const IS_JOIN_LEAGUE_LOADING = 'IS_JOIN_LEAGUE_LOADING';
export const JOIN_LEAGUE_FETCH_DATA_SUCCESS = 'JOIN_LEAGUE_FETCH_DATA_SUCCESS';
export const JOIN_LEAGUE_HAS_ERROR = 'JOIN_LEAGUE_HAS_ERROR';
export const IS_LEAVE_LEAGUE_LOADING = 'IS_LEAVE_LEAGUE_LOADING';
export const LEAVE_LEAGUE_FETCH_DATA_SUCCESS = 'LEAVE_LEAGUE_FETCH_DATA_SUCCESS';
export const LEAVE_LEAGUE_HAS_ERROR = 'LEAVE_LEAGUE_HAS_ERROR';
export const IS_RELAUNCH_LEAGUE_LOADING = 'IS_RELAUNCH_LEAGUE_LOADING';
export const RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS = 'RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS';
export const RELAUNCH_LEAGUE_HAS_ERROR = 'RELAUNCH_LEAGUE_HAS_ERROR';
export const IS_RE_JOIN_LEAGUE_LOADING = 'IS_RE_JOIN_LEAGUE_LOADING';
export const RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS = 'RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS';
export const RE_JOIN_LEAGUE_HAS_ERROR = 'RE_JOIN_LEAGUE_HAS_ERROR';
export const IS_DELETE_LEAGUE_LOADING = 'IS_DELETE_LEAGUE_LOADING';
export const DELETE_LEAGUE_FETCH_DATA_SUCCESS = 'DELETE_LEAGUE_FETCH_DATA_SUCCESS';
export const DELETE_LEAGUE_HAS_ERROR = 'DELETE_LEAGUE_HAS_ERROR';
export const IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING = 'IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING';
export const PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS = 'PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS';
export const PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR = 'PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR';
export const IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING = 'IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING';
export const PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS = 'PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS';
export const PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR = 'PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR';
export const IS_SUSPEND_LEAGUE_LOADING = 'IS_SUSPEND_LEAGUE_LOADING';
export const SUSPEND_LEAGUE_FETCH_DATA_SUCCESS = 'SUSPEND_LEAGUE_FETCH_DATA_SUCCESS';
export const SUSPEND_LEAGUE_HAS_ERROR = 'SUSPEND_LEAGUE_HAS_ERROR';
export const IS_REMOVE_SUSPENSION_LOADING = 'IS_REMOVE_SUSPENSION_LOADING';
export const REMOVE_SUSPENSION_FETCH_DATA_SUCCESS = 'REMOVE_SUSPENSION_FETCH_DATA_SUCCESS';
export const REMOVE_SUSPENSION_HAS_ERROR = 'REMOVE_SUSPENSION_HAS_ERROR';
export const UPDATE_BOOSTER_STATUS = 'UPDATE_BOOSTER_STATUS';
export const REMOVE_ALL = 'REMOVE_ALL';
/*-----/save substitution api/------*/
export const IS_SUBSTITUTION_TEAM_LOADING = 'IS_SUBSTITUTION_TEAM_LOADING';
export const SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS = 'SUBSTITUTION_TEAM_FETCH_DATA_SUCCESS';
export const SUBSTITUTION_TEAM_HAS_ERROR = 'SUBSTITUTION_TEAM_HAS_ERROR';
export const IS_PUBLIC_LEAGUES_LOADING = 'IS_PUBLIC_LEAGUES_LOADING';
export const PUBLIC_LEAGUES_FETCH_DATA_SUCCESS = 'PUBLIC_LEAGUES_FETCH_DATA_SUCCESS';
export const PUBLIC_LEAGUES_HAS_ERROR = 'PUBLIC_LEAGUES_HAS_ERROR';
export const IS_LEAGUE_LEADERBOARD_LOADING = 'IS_LEAGUE_LEADERBOARD_LOADING';
export const LEAGUE_LEADERBOARD_HAS_ERROR = 'LEAGUE_LEADERBOARD_HAS_ERROR';
export const LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS = 'LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS';
export const IS_RENAME_LEAGUE_LOADING = 'IS_RENAME_LEAGUE_LOADING';
export const RENAME_LEAGUE_HAS_ERROR = 'RENAME_LEAGUE_HAS_ERROR';
export const RENAME_LEAGUE_FETCH_DATA_SUCCESS = 'RENAME_LEAGUE_FETCH_DATA_SUCCESS';
export const IS_LEAGUE_LEADERBOARD_PUBLIC_LOADING = 'IS_LEAGUE_LEADERBOARD_PUBLIC_LOADING';
export const LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS = 'LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS';
export const LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR = 'LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR';
export const IS_LEAGUE_LEADERBOARD_RANK__LOADING = 'IS_LEAGUE_LEADERBOARD_RANK__LOADING';
export const LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS = 'LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS';
export const LEAGUE_LEADERBOARD_RANK__HAS_ERROR = 'LEAGUE_LEADERBOARD_RANK__HAS_ERROR';
export const IS_GET_OTHERS_TEAM_LOADING = 'IS_GET_OTHERS_TEAM_LOADING';
export const GET_OTHERS_TEAM_SUCCESS = 'GET_OTHERS_TEAM_SUCCESS';
export const GET_OTHERS_TEAM_HAS_ERROR = 'GET_OTHERS_TEAM_HAS_ERROR';
export const UPDATE_FAV_TEAM_LOADING = 'UPDATE_FAV_TEAM_LOADING';
export const UPDATE_FAV_TEAM_SUCCESS = 'UPDATE_FAV_TEAM_SUCCESS';
export const UPDATE_FAV_TEAM_ERROR = 'UPDATE_FAV_TEAM_ERROR';

/*-----/save captain api/------*/
export const IS_CAPTAIN_LOADING = 'IS_CAPTAIN_LOADING';
export const CAPTAIN_FETCH_DATA_SUCCESS = 'CAPTAIN_FETCH_DATA_SUCCESS';
export const CAPTAIN_HAS_ERROR = 'CAPTAIN_HAS_ERROR';
/*-----/ set popup stats /------*/
export const SET_POPUP_STATE = 'SET_POPUP_STATE';
/*-----/ set booster popup stats /------*/
export const SET_BOOSTER_POPUP_STATE = 'SET_BOOSTER_POPUP_STATE';
/*-----Auth api------*/
export const UPDATE_SAVE_BTN_STATUS = 'UPDATE_SAVE_BTN_STATUS';
export const UPDATE_USER_TOKEN = 'USER_TOKEN';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
/*-----/Auth api------*/
/*-----/get subscribe info api------*/
export const IS_SUBSCRIBE_INFO_LOADING = 'IS_SUBSCRIBE_INFO_LOADING';
export const SUBSCRIBE_INFO_FETCH_DATA_SUCCESS = 'SUBSCRIBE_INFO_FETCH_DATA_SUCCESS';
export const SUBSCRIBE_INFO_HAS_ERROR = 'SUBSCRIBE_INFO_HAS_ERROR';
/*-----/post team name api------*/
export const IS_UPDATED_TEAM_NAME_LOADING = 'IS_UPDATED_TEAM_NAME_LOADING';
export const UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS = 'UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS';
export const UPDATED_TEAM_NAME_HAS_ERROR = 'UPDATED_TEAM_NAME_HAS_ERROR';
/*-----/post delete fantasy team api------*/
export const IS_DELETE_FANTASY_TEAM_LOADING = 'IS_DELETE_FANTASY_TEAM_LOADING';
export const DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS = 'DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS';
export const DELETE_FANTASY_TEAM_HAS_ERROR = 'DELETE_FANTASY_TEAM_HAS_ERROR';
/*-----/upcoming fixtures popup------*/
export const TRIGGER_HANDLE_FIXTURE_POPUP = 'TRIGGER_HANDLE_FIXTURE_POPUP';
/*-------Rules-------*/
export const IS_RULES_LOADING = 'IS_RULES_LOADING';
export const RULES_FETCH_DATA_SUCCESS = 'RULES_FETCH_DATA_SUCCESS';
export const RULES_HAS_ERROR = 'RULES_HAS_ERROR';
/* team Lock Toast local storage */
export const SET_TEAM_LOCK_TOAST_COOKIE = 'SET_TEAM_LOCK_TOAST_COOKIE';
export const SET_TOTAL_POINTS = 'SET_TOTAL_POINTS';
/* match details api */
export const IS_MATCH_DETAILS_LOADING = 'IS_MATCH_DETAILS_LOADING';
export const MATCH_DETAILS_HAS_ERROR = 'MATCH_DETAILS_HAS_ERROR';
export const MATCH_DETAILS_FETCH_DATA_SUCCESS = 'MATCH_DETAILS_FETCH_DATA_SUCCESS';

/* share team */

export const IS_SHARE_TEAM_LOADING = 'IS_SHARE_TEAM_LOADING';
export const TEAM_SHARE_SUCCESS = 'TEAM_SHARE_SUCCESS';
export const TEAM_SHARE_ERROR = 'TEAM_SHARE_ERROR';
export const TEAM_SHARE_CLEAR = 'TEAM_SHARE_CLEAR';

/*eos api call*/
export const IS_EOS_LOADING = 'IS_EOS_LOADING';
export const EOS_FETCH_DATA_SUCCESS = 'EOS_FETCH_DATA_SUCCESS';
export const EOS_HAS_ERROR = 'EOS_HAS_ERROR';

// Landing Trans
export const LANDING_TRANS_LOADING = 'LANDING_TRANS_LOADING';
export const LANDING_TRANS_SUCCESS = 'LANDING_TRANS_SUCCESS';
export const LANDING_TRANS_ERROR = 'LANDING_TRANS_ERROR';

export const GAMING_HUB_LOADED = 'GAMING_HUB_LOADED';


export const CLOSE_DYNAMIC_CARD = 'CLOSE_DYNAMIC_CARD';


// WEBPACK FOOTER //
// ./src/constants/action-types.js